export enum PlatformType {
    IOS = 'IOS',
    ANDROID = 'ANDROID'
}
